$(() => {
  const helpElements = $('[data-toggle="help"]')
  if (!helpElements.length) {
    return
  }

  helpElements.each((_, element) => {
    const helpText = $(element).data('help')
    if (helpText?.length) {
      const iconElement = $(
        '<i>',
        {
          class: 'fal fa-question-circle ml-2',
          data: { placement: 'top', html: true, title: helpText }
        }
      )
      $(element).after(iconElement)
      iconElement.tooltip()
    }
  })
})
